import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
// FAQPage-structured data lægges statisk i forsidens HTML af scripts/prerender.mjs.
import FAQS from "@/data/faq.json";

const FaqSection = () => {
  return (
    <section className="e-graphite-section py-10 md:py-14 reveal-on-scroll" data-testid="faq-section">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-10">
          <p className="text-[#00F0FF] text-xs font-bold tracking-[0.3em] uppercase mb-5">Ofte stillede spørgsmål</p>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-light text-white tracking-tight">
            Spørgsmål &amp; svar
          </h2>
        </div>
        <Accordion type="single" collapsible className="space-y-3">
          {FAQS.map((f, idx) => (
            <AccordionItem
              key={f.q}
              value={`faq-${idx}`}
              className="bg-white/[0.03] border border-white/10 rounded-sm px-5 data-[state=open]:border-[#00F0FF]/50"
              data-testid={`faq-item-${idx}`}
            >
              <AccordionTrigger className="text-left text-white font-bold text-base hover:no-underline" style={{ fontFamily: 'Saira' }} data-testid={`faq-trigger-${idx}`}>
                {f.q}
              </AccordionTrigger>
              <AccordionContent className="text-[#A0AEC0] text-base leading-relaxed" data-testid={`faq-answer-${idx}`}>
                {f.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
        <p className="text-center text-[#A0AEC0] text-sm mt-8">
          Har du et andet spørgsmål? Ring på{" "}
          <a href="tel:+4593954164" className="text-[#00F0FF] hover:underline font-bold" data-testid="faq-contact-phone">+45 93 95 41 64</a>.
        </p>
      </div>
    </section>
  );
};

export default FaqSection;
